import { render, staticRenderFns } from "./ForgotPasswordHelpModal.vue?vue&type=template&id=35213d25&scoped=true"
import script from "./ForgotPasswordHelpModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordHelpModal.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordHelpModal.vue?vue&type=style&index=0&id=35213d25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35213d25",
  null
  
)

export default component.exports